import AppContent from '@components/App/appContent';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import { withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';


const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

class TuqqiReport extends React.Component {

    componentDidMount() {
        // this.loadData();
        if (this.props.userData.profileData.org.orgUid === 'tuqqi') {

        }
        this.props.adminService.getDashboardToken().then((res) => {

            window.Cumulio.addDashboard({
                dashboardId: '37885168-32ec-4cc9-bd11-89fcca93ef9c',
                container: '#my-dashboard',
                key: res.id,
                token: res.token,
                language: 'en'
            });

            // window.Cumulio.addDashboard({
            //     dashboardId: 'b7c96462-b622-46cb-9d27-eb96bd8143f3',
            //     container: '#my-dashboard2',
            //     key: res.id,
            //     token: res.token,
            //     language: 'en-US'
            // });
        })
    }

    render() {
        return <AppContent >
            <PageContentWrapper isFull={true} drawer={<AdminSettingsDrawer selected="time_tracking" />}>
                {/* {this.props.token ? <iframe style={{ border: 'none' }} src={"/graph/index.html?token=" + this.props.token} width="100%" height="1500px" /> : <div data-intrcm-id="tuqqi_5j95k4wt" />} */}
                <div data-intrcm-id="tuqqi_ep1x0tjy" id={"my-dashboard"}>

                </div>
                {/* <div data-intrcm-id="tuqqi_ybet6kqm" id={"my-dashboard2"}>

                </div> */}
            </PageContentWrapper>
        </AppContent>;
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    templates: state.globalData.templates,
    token: state.userData.idToken,
    userData: state.userData,

})


const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(TuqqiReport);